import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import AppWrapper from '../../../components/AppWrapper';
import PageTitle from '../../../components/PageTitle';
import SearchBar from '../../../components/SearchBar';
import TableBasic from '../../../components/Tablebasic';
import { bulkEmailColumns } from '../../../utils/const';
import { breachcrumbPath } from '../../../utils/breadcrumbConst';
import { useBulkEmail } from '../../../hooks/useBulkEmail';
import { LinkComponent } from '../../../components/Link';
import { FlexRowStyled } from '../../../styles/Flexbox';

const BulkEmail = () => {
  const location: any = useLocation();
  const { indexNewsletterEmail, newsletters } = useBulkEmail();

  const [toastMessage, setToastMessage] = useState<IToastMessage>();

  useEffect(() => {
    indexNewsletterEmail();
  }, []);

  useEffect(() => {
    if (location.state?.toastMessage) {
      setToastMessage(location.state.toastMessage);
    }
  }, [location]);

  return (
    <AppWrapper
      toastMessage={toastMessage}
      breadcrumbs={[breachcrumbPath.admin, breachcrumbPath.bulkEmail]}
    >
      <PageTitle
        title="Select newsletter or Create Bulk Email"
        linkUrl="/admin/bulkEmail/add"
        buttonText="Create Bulk Email"
        useIcon
        showButton
      />

      <LinkComponent url="/admin/bulkEmail/settings" theme="button">
        <FlexRowStyled style={{ alignContent: 'center' }}>
          <div style={{ paddingTop: '2px', color: 'black' }}>
            <FontAwesomeIcon
              style={{ marginLeft: '5px', marginBottom: '20px', fontSize: '16px' }}
              icon={faGear}
            />
          </div>
          <div
            style={{
              marginLeft: '5px',
              fontSize: '15px',
              color: 'black',
              fontFamily:
                'Roboto, "Lucida Grande", "DejaVu Sans", "Bitstream Vera Sans", Verdana, Arial, sans-serif',
            }}
          >
            Settings
          </div>
        </FlexRowStyled>
      </LinkComponent>
      <SearchBar
        handleSearch={() => 1}
        setSearchValue={() => 1}
        searchValue=""
        searchCount={0}
        total={0}
      />
      <TableBasic
        data={newsletters}
        columns={bulkEmailColumns}
        selectedList={[]}
        handleCheck={() => 1}
        footerText={`Total (${newsletters.length}) newsletters`}
        basicUrl="bulkEmail"
        checkBoxColumn={false}
      />
    </AppWrapper>
  );
};

export default BulkEmail;
